export const PICKLEBALL_EVENT_CATEGORIES = [
  { value: 'Men’s Singles', label: 'Men’s Singles' },
  { value: 'Women’s Singles', label: 'Women’s Singles' },
  { value: 'Men’s Doubles', label: 'Men’s Doubles' },
  { value: 'Women’s Doubles', label: 'Women’s Doubles' },
  { value: 'Mixed Doubles', label: 'Mixed Doubles' },
  { value: 'Team Doubles', label: 'Team Doubles' },
] as const;

export type PickleballEventCategory = (typeof PICKLEBALL_EVENT_CATEGORIES)[number]['value'];

export const isPickleballDoubles = (eventCategory?: string): boolean =>
  /doubles/i.test(eventCategory || '');

export const getPickleballPlayersPerSide = (eventCategory?: string): 1 | 2 =>
  isPickleballDoubles(eventCategory) ? 2 : 1;

export const normalizePickleballEventCategories = (eventCategories: unknown): PickleballEventCategory[] => {
  const selectedCategories = Array.isArray(eventCategories) ? eventCategories : [];
  const allowedCategories = new Set(PICKLEBALL_EVENT_CATEGORIES.map((option) => option.value));

  return selectedCategories.filter(
    (category): category is PickleballEventCategory =>
      typeof category === 'string' && allowedCategories.has(category as PickleballEventCategory)
  );
};
